<script lang="ts">
    import { Accordion, AccordionItem, Col,Row } from "sveltestrap";
    import { QuickQuestionsareanswered } from "../../../utils/Constant/Constant";
    import FeatherIcon from "svelte-feather-icon";
    import {questionFaqData} from "../../../Data/FAQ/FAQ"
    import SearchArticles from "./SearchArticles.svelte";
    import QuestionFaqSub from "./QuestionFaqSub.svelte";
</script>

<Col lg="12">
  <div class="header-faq">
    <h5 class="mb-0">{QuickQuestionsareanswered}</h5>
  </div>
  <Row class="default-according style-1 faq-accordion ">
    <Col xl="8" lg="6" md="7" class="xl-60 box-col-8">
      {#each questionFaqData as faqItem}
        <Accordion>
          <AccordionItem>
            <h5 class="mb-0 text-truncate" slot="header">
              <FeatherIcon icon="help-circle" />
              {faqItem.btnname}
            </h5>
            {faqItem.discription}
          </AccordionItem>
        </Accordion>
      {/each}
      <QuestionFaqSub />
    </Col>
    <SearchArticles />
  </Row>
</Col>
